import {
  MultiSelectorBadgeValue,
  FormMultiSelectorProps,
  MultiSelector,
  FormControl,
  FormMessage,
  FormField,
  FormItem,
} from '@ui/components';
import { LabelsPicker } from '@shared/components/labels-picker';
import { LabelType } from '@interfaces/models';
import { FieldValues } from 'react-hook-form';
import { ComponentProps } from 'react';
import { cn } from '@ui/utils';

export interface FormLabelsPickerProp<T extends FieldValues = FieldValues>
  extends Omit<FormMultiSelectorProps<T>, 'componentProps' | 'options'> {
  componentProps?: Partial<ComponentProps<typeof MultiSelector>> & { hasShadow?: boolean };
  labelType: LabelType;
}

export const FormLabelsPicker = <T extends FieldValues>({
  componentProps,
  placeholder,
  formControl,
  labelType,
  className,
  disabled,
  required,
  floating,
  size,
  name,
}: FormLabelsPickerProp<T>) => {
  return (
    <FormField
      render={({ field, fieldState }) => (
        <FormItem className={cn('relative', className)}>
          <FormControl>
            <LabelsPicker
              onValuesChange={(value) => {
                field.onChange(value);
              }}
              componentProps={componentProps}
              searchPlaceholder={placeholder}
              hasError={!!fieldState.error}
              labelType={labelType}
              values={field.value}
              disabled={disabled}
              required={required}
              floating={floating}
              size={size}
            >
              <MultiSelectorBadgeValue placeholder={placeholder} size="small" removeable />
            </LabelsPicker>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
      control={formControl}
      name={name}
    />
  );
};
